import React, { memo, useCallback } from 'react'
import { makeStyles } from '@material-ui/styles'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/CloseRounded'
import { useHistory } from 'react-router'
import { useTranslation } from 'react-i18next'

import styles from './styles'

const useStyles = makeStyles(styles)

const Header: React.FunctionComponent<any> = props => {
	const { companyName, displayName } = props
	const history = useHistory()
	const classes = useStyles()
	const goBack = useCallback(() => {
		history.goBack()
	}, [history])
	const { t } = useTranslation()
	return (
		<div className={classes.headerContainer}>
			<IconButton className={classes.closeButton} onClick={goBack}>
				<CloseIcon />
			</IconButton>
			<div className={classes.titleSection}>
				<div className={classes.headerTitle}>
					{displayName
						? t('Welcome, CompanyName!', {
								companyName: companyName,
						  })
						: ' Create a company profile!'}
				</div>
			</div>
		</div>
	)
}

export default memo((props: any) => <Header {...props} />)
